'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    StoreUtils = require('../utils/StoreUtils'),
    StampStore = require('./StampStore'),
    ZineStore = require('./ZineStore'),
    Messages = require('../constants/NotificationMessages'),
    { filter } = require('underscore'),
    createStore = StoreUtils.createStore;

var STACK_LENGTH_LIMIT = 3,
    NORMAL_DURATION = 5 * 1000,
    ACTION_DURATION = 250 * 1000;

var _notificationStack = [];

function isSticky(id) {
  switch (id) {
    case Messages.UNSUPPORTED_BROWSER:
    case Messages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION:
    case Messages.USER_NEW_EMAIL_NEEDS_CONFIRMATION:
      return true;
  }

  return false;
}

function hasAction(id) {
  switch (id) {
  case Messages.STAMP_HAS_BEEN_SAVED:
  case Messages.WELCOME_FOLLOW_ZINES:
  case Messages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION:
  case Messages.USER_NEW_EMAIL_NEEDS_CONFIRMATION:
  case Messages.EMAIL_UNSUBSCRIBE:
    return true;
  }
}

function getDuration(id) {
  if (isSticky(id)) {
    return 0;
  } else if (hasAction(id)) {
    return ACTION_DURATION;
  } else {
    return NORMAL_DURATION;
  }
}

function setNotification(notification) {
  _notificationStack = [notification].concat(_notificationStack);

  if (_notificationStack.length > STACK_LENGTH_LIMIT) {
    var stickyCount = filter(_notificationStack, n => isSticky(n.id)).length;

    _notificationStack = filter(_notificationStack, (n, idx) => {
      return idx < (STACK_LENGTH_LIMIT - stickyCount) || isSticky(n.id);
    });
  }
}

function hideNotification(action) {
  _notificationStack = _notificationStack.filter(n =>
    n.id !== action.id ||
    (action.created && action.created !== n.created)
  );
}

var NotificationStore = createStore({
  getNotifications() {
    return _notificationStack;
  },

  getDuration: getDuration
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([StampStore.dispatchToken, ZineStore.dispatchToken]);

  var action = payload.action;

  switch (action.type) {
  case ActionTypes.SHOW_NOTIFICATION:
    setNotification(action.notification);
    NotificationStore.emitChange();
    break;

  case ActionTypes.HIDE_NOTIFICATION:
    hideNotification(action);
    NotificationStore.emitChange();
    break;
  }
});

module.exports = NotificationStore;


/** WEBPACK FOOTER **
 ** ./stores/NotificationStore.js
 **/